const firstValueInQueryObject = (queryObject, key) => {
  const object = queryObject?.[key];
  return object?.[0];
};

export default firstValueInQueryObject;
